export const I18N_LOCAL_STORAGE_KEY = "i18nextLngCustom";
